import React from 'react';
import { Eye } from 'lucide-react';

interface ImageThumbnailProps {
  src: string;
  alt: string;
  onClick?: () => void;
  className?: string;
}

const ImageThumbnail: React.FC<ImageThumbnailProps> = ({
  src,
  alt,
  onClick,
  className = ''
}) => {
  const getImageSrc = (imageData: string) => {
    if (imageData.startsWith('data:image/')) {
      return imageData;
    }
    return `data:image/jpeg;base64,${imageData}`;
  };

  return (
    <div className={`relative group cursor-pointer ${className}`} onClick={onClick}>
      <img 
        src={getImageSrc(src)}
        alt={alt}
        className="w-12 h-12 object-cover rounded border border-gray-200 group-hover:border-[#07E5D1] transition-colors"
      />
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center rounded">
        <Eye className="h-3 w-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
      </div>
    </div>
  );
};

export default ImageThumbnail;